import React, { useMemo, useState } from 'react';
import './MonthFilter.css';

function MonthFilter({ title = 'Meses', options = [], selectedMonths = [], onChange }) {
  const [query, setQuery] = useState('');

  const filteredOptions = useMemo(() => {
    if (!options.length) {
      return [];
    }

    if (!query.trim()) {
      return options;
    }

    const normalizedQuery = query.trim().toLowerCase();
    return options.filter((option) => option.label.toLowerCase().includes(normalizedQuery) || option.value.includes(normalizedQuery));
  }, [options, query]);

  if (!options.length) {
    return null;
  }

  const toggleMonth = (month) => {
    if (selectedMonths.includes(month)) {
      onChange(selectedMonths.filter((item) => item !== month));
      return;
    }

    onChange([...selectedMonths, month].sort((a, b) => b.localeCompare(a)));
  };

  const selectVisible = () => {
    const merged = Array.from(new Set([...selectedMonths, ...filteredOptions.map((item) => item.value)]));
    onChange(merged.sort((a, b) => b.localeCompare(a)));
  };

  return (
    <div className="month-filter card">
      <div className="month-filter-header">
        <h3>{title}</h3>
        <div className="month-filter-actions">
          <button type="button" className="month-filter-clear" onClick={selectVisible}>
            Marcar visiveis
          </button>
          {selectedMonths.length > 0 && (
            <button
              type="button"
              className="month-filter-clear"
              onClick={() => onChange([])}
            >
              Limpar
            </button>
          )}
        </div>
      </div>

      <input
        type="text"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        className="month-filter-search"
        placeholder="Buscar mes (ex: abr, 2026-04)"
      />

      <div className={`month-filter-options ${filteredOptions.length > 8 ? 'month-filter-options-scroll' : ''}`}>
        {filteredOptions.map((option) => (
          <button
            type="button"
            key={option.value}
            className={`month-chip ${selectedMonths.includes(option.value) ? 'active' : ''}`}
            onClick={() => toggleMonth(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
      <p className="month-filter-help">
        Selecione um ou varios meses. Sem selecao = todos os meses listados. Exibindo {filteredOptions.length} de {options.length} meses.
      </p>
    </div>
  );
}

export default MonthFilter;
